<template>
  <section
    class="cs-input"
    :class="{
      'cs-input_mode2': mode === 2,
      'cs-input_in-dd': inDropdown,
    }"
  >
    <label v-if="label && mode === 2" class="cs-input__label" :for="id">
      {{ label }}
    </label>
    <label v-if="mode === 2" :for="id" class="cs-input__icon">
      <img
        v-if="mode === 2 && !inDropdown"
        src="@/assets/img/search.svg"
        alt="search icon"
      />
      <img
        v-if="mode === 2 && inDropdown"
        src="@/assets/img/search-2.svg"
        alt="search icon"
      />
    </label>
    <div class="input-wrapper">
      <input
        :name="name"
        :id="name"
        :type="type"
        :value="inputValue"
        :placeholder="placeholder"
        @input="handleChange"
        @blur="handleBlur"
        :autocomplete="autocomplete"
        :readonly="autocomplete === 'off'"
        :disabled="disabled"
        @focusin="toggleReadonly($event)"
        @focusout="toggleReadonly($event), clearSeach()"
        class="input-wrapper__input"
        :class="{
          'cs-input__input_error': error,
          'cs-input__input_small': small,
        }"
        @change="$emit('change', $event)"
        v-on:keyup.enter="$emit('enter')"
        @click.right="handleRightClick($event)"
        @copy="copyText($event)"
      />
      <span v-if="imgSource" @click="$emit('handle-input-icon')">
        <img :id="id" :src="imgSource" />
      </span>
    </div>
    <small class="cs-sign-in__error" v-if="errorMessage">
        {{ errorMessage }}
      </small>
    <b-tooltip
      :target="id"
      class="tooltip"
      triggers="hover"
      placement="bottom"
      v-if="showTooltip"
    >
      Minimum 8 characters. Combination of uppercase, lowercase, alphabet,
      number & special characters.
    </b-tooltip>
  </section>
</template>

<script>
import { useField } from "vee-validate";
import * as Yup from 'yup';
export default {
  name: "TextInput",
  props: {
    id: {
      type: String,
      default: "input",
    },
    type: {
      type: String,
      default: "text",
    },
    value: [String, Number],
    name: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    autocomplete: String,
    // mode == 2 - serach input with icon
    mode: {
      type: Number,
      default: 1,
    },
    // специальные стили для поиска в выпадающем списке
    inDropdown: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    imgSource: {
      type: String,
      default: "",
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledCopy: {
      type: Boolean,
      default: false,
    },
    disabledRightClick: {
      type: Boolean,
      default: false,
    },
    schema: Object,
  },
  setup(props, { emit }) {
    // eslint-disable-next-line vue/no-setup-props-destructure
    let schema = props.schema;
    if(!props.schema) {
      schema = Yup.string();
    }
    const {
      value: inputValue,
      errorMessage,
      errors,
      handleBlur,
      handleChange: change,
      meta,
    } = useField(props.name, schema, {
      initialValue: props.value,
    });
    const handleChange = (event) => {
      emit('update:value', event.target.value);
      change(event);
    };
    return {
      handleChange,
      errors,
      inputValue,
      errorMessage,
      handleBlur,
      meta,
    };
  },
  methods: {
    clearSeach() {
      if (this.mode === 2 && this.inDropdown) {
        this.$emit("clearSearch");
      }
    },
    toggleReadonly(event) {
      if (this.autocomplete === "off") {
        event.preventDefault();
        if (event.target.getAttribute("readonly") === "readonly") {
          event.target.removeAttribute("readonly");
        } else {
          event.target.setAttribute("readonly", "readonly");
        }
      }
    },
    copyText(e) {
      if (this.disabledCopy) {
        e.preventDefault();
      }
    },
    handleRightClick(e) {
      if (this.disabledRightClick) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-input {
  &__label {
    display: block;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 6px;
  }
  .input-wrapper {
    position: relative;
    &__input {
      width: 100%;
      padding: 10px;
      color: #1b1f3b;
      font-weight: 300;
      font-size: 16px;
      display: flex;
      align-items: center;
      border-radius: 4px;
      background-color: #fff;
      border: 1px solid #b2b7c5;
      letter-spacing: 0.04em;
      transition: 0.35s;
      &_error {
        border-color: $red600;
      }
      &_small {
        height: 52px;
      }
      &::placeholder {
        color: $black400;
        font-weight: 300;
      }
      &:hover,
      &:focus {
        border-color: $black500;
      }
      &:disabled {
        background-color: $black200 !important;
        border-color: $black200 !important;
        &:hover,
        &:focus {
          border-color: $black200 !important;
        }
      }
    }
    img {
      width: 20px;
      position: absolute;
      right: 10px;
      top: 0;
      cursor: pointer;
      height: 19px;
      bottom: 0;
      margin: auto;
    }
  }
}

.cs-input_mode2.cs-input {
  position: relative;

  & .cs-input__icon {
    position: absolute;
    width: 27px;
    min-width: 27px;
    height: 27px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 15px;
    bottom: 15px;
  }

  & .cs-input__input {
    padding-left: 52px;
    &::placeholder {
      color: $black400;
      font-weight: 500;
    }
  }
}

.cs-input_in-dd.cs-input {
  & .cs-input__icon {
    position: absolute;
    width: 30px;
    min-width: 30px;
    height: 30px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 15px;
    bottom: 7px;
  }

  & .cs-input__input {
    height: 44px;
    border-top: none;
    padding-left: 45px;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    &:hover,
    &:focus {
      border-color: $border;
    }
    &::placeholder {
      font-size: 14px;
      line-height: 16px;
      color: $grey;
      font-weight: 300;
    }
  }
  .tooltip {
    border: 1px solid #828ba1;
    background-color: #fff !important;
    color: #6e728b;
  }
}
</style>
